import { FC } from 'react'

import { translate } from '~/utils/translate'

import * as Styled from './styles'

export const ProcessingImageErrorFeedback: FC = () => {
  return (
    <Styled.Container>
      <Styled.Image
        src="https://doris-media-production.imgix.net/mix-static-assets/surprised-emoji.png"
        data-testid="emoji-image"
      />
      <Styled.Title data-testid="pief-title">{translate('IMAGE_INPUT_PROCESSING_ERROR_TITLE')}</Styled.Title>
      <Styled.Message data-testid="pief-description">
        {translate('IMAGE_INPUT_PROCESSING_ERROR_DESCRIPTION')}
      </Styled.Message>
    </Styled.Container>
  )
}
